import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import { useSettingsPage } from "./SettingsPageContext";

type Props = {
    /** Supplier model key the master toggle writes. */
    name: string;
    titleKey: string;
    descriptionKey: string;
    iconClass: string;
    active: boolean;
    toggleFn: (e: any) => void;
    disabled?: boolean;
    showDisableConfirm?: boolean;
};

/**
 * The master toggle of a module section (Quotes, Inventory, Shipping...). Sits at the top of the
 * section; when off, the section collapses to a one-line note (see SettingsSection).
 */
export const SettingsModuleHero = (props: Props) => {
    const page = useSettingsPage();
    const edited = page.isEdited(props.name);

    return (
        <div className={"SettingsModuleHero" + (edited ? " edited" : "")} id={`row-${props.name}`} data-testid={`hero-${props.name}`}>
            <div className={"SettingsModuleHero-icon" + (props.active ? " on" : "")}>
                <i className={props.iconClass} aria-hidden={true} />
            </div>
            <div className={"SettingsModuleHero-text"}>
                <h3 className={"SettingsModuleHero-title"}>
                    <OwLabel title={props.titleKey} noBottomMargin={true} />
                </h3>
                <p className={"SettingsModuleHero-description"}>
                    <OwLabel title={props.descriptionKey} noBottomMargin={true} />
                </p>
            </div>
            {edited ? (
                <span className={"SettingsChip brand"}>
                    <OwLabel title={"edited"} noBottomMargin={true} />
                </span>
            ) : null}
            <span className={"SettingsChip " + (props.active ? "on" : "")}>
                <OwLabel title={props.active ? "on" : "off"} noBottomMargin={true} />
            </span>
            <OwToggle
                size={"small"}
                active={props.active}
                name={props.name}
                fn={props.toggleFn}
                label={""}
                disabled={props.disabled}
                showDisableConfirm={props.showDisableConfirm}
            />
        </div>
    );
};

export default SettingsModuleHero;
